import React, { Component } from 'react';
import {$} from 'jquery';
import  { Redirect } from 'react-router-dom'
import API_Config from '../API_Config';
import PropTypes from 'prop-types';
import './search.css'
class Search extends Component {

    static contextTypes = {
        router: PropTypes.object
    }
    constructor(props,context) {
        super(props,context);
        this.state = {
            data:[ {
                _id: '',
                id: '',
                title: '',
                slug : ''
            }],
            isData:false,
            isDataAvail:false,
            slug   : '',
        };
        this.handleBlur = this.handleBlur.bind(this)



    }

    GetContentData(params) {
        let url = API_Config.http_url+'/reports/search?q='+params+'';
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {

                    console.log(result)

                    if(result.length > 0) {

                        result = result.filter(function(n){ return n != undefined });
                        this.setState({
                            data: result,
                            isData:true
                        });
                    } else {
                        console.log("error","no data found")
                       // localStorage.setItem("strSrch","");
                        this.setState({
                            data: [],
                            isData:false
                        });
                    }

                },
                (error) => {
                   if(error.data == "No data found.") {
                       localStorage.setItem("strSrch","");
                   }

                    this.setState({
                        data: [],
                        isData:false,
                        isDataAvail:true,
                    });
                }
            )

    }
    _handleKeyPress(e) {

        if (e.key === 'Enter') {

            window.location.href ="/industry-reports";
            // this.context.router.history.push("/industry-reports");

            //this.props.history.push("/industry-reports")

        }
    }
    handleBlur(e) {
        console.log("Enter Da")
        if (e.key === 'Enter') {

            window.location.href ="/industry-reports";
            // this.context.router.history.push("/industry-reports");

            //this.props.history.push("/industry-reports")

        } else {
            let data = document.getElementById('auto_reports_top').value;
            localStorage.setItem('strSrch',data);

            if(data !== "") {
                this.GetContentData(data)
            } else {
                this.setState({
                    isData:false
                });
            }
        }


    }
    showModalView(data) {
        localStorage.setItem('strSrch',"");
    }
    render() {

        if(this.state.isData) {
            return (

                <div  className="col-md-7" id="head-sdiv">
                    <div className="input-group">
                        <input type="hidden" name="search_param" value="all" id="search_param" />
                        <input type="text" className="form-control mid-search " onKeyUp={this.handleBlur} onKeyPress={this._handleKeyPress} ref="searchInput" name="search" id="auto_reports_top" placeholder="Search Report Store . . ." autoComplete="off" />
                        <span className="input-group-btn ">

                                <button className="btn btn-default sear-btn" type="submit" id="head-sbtn"><span className="fa fa-search grt"></span></button>

                        </span>
                    </div>


                    <div id="suggesstion-box">
                        <ul id="country-list">
                            <div className="suggesstion_div">
                                <span className="suggestion_span">
                                    <i>
                                            Showing {this.state.data.length} entries
                                    </i>
                                </span>
                            </div>
                            {
                                this.state.data.map(
                                    i => {
                                        return (
                                            <li>
                                                <a href={"/industry-reports/" + i.slug} onClick={() => this.showModalView(i)}>
                                                    {i.title}
                                                </a>
                                                <hr/>
                                            </li>

                                        )
                                    }
                                )
                            }


                        </ul>
                    </div>


                </div>

            );
        }
        else if(!this.state.isData && this.state.isDataAvail) {
            return (
            <div  className="col-md-7" id="head-sdiv">
                <div className="input-group">
                    <input type="hidden" name="search_param" value="all" id="search_param" />
                    <input type="text" className="form-control mid-search " onKeyUp={this.handleBlur} onKeyPress={this._handleKeyPress} ref="searchInput" name="search" id="auto_reports_top" placeholder="Search Report Store . . ." autoComplete="off" />
                    <span className="input-group-btn ">

                                <button className="btn btn-default sear-btn" type="submit" id="head-sbtn"><span className="fa fa-search grt"></span></button>

                        </span>
                </div>


                <div id="suggesstion-box">
                    <ul id="country-list">
                        <div className="suggesstion_div">
                                <span className="suggestion_span">
                                    <i>
                                            No data avaible for this s entries
                                    </i>
                                </span>
                        </div>
                    </ul>
                </div>


            </div>
            )
        }
        else {
            return (

                    <div  className="col-md-7" id="head-sdiv">
                        <div className="input-group">
                            <input type="hidden" name="search_param" value="all" id="search_param" />
                            <input type="text" className="form-control mid-search " onKeyUp={this.handleBlur} name="search" id="auto_reports_top" ref="searchInput" placeholder="Search Report Store . . ." autoComplete="off" />
                            <span className="input-group-btn ">

                                <button className="btn btn-default sear-btn" type="submit" id="head-sbtn"><span className="fa fa-search grt"></span></button>

                        </span>
                        </div>

                    </div>


            );
        }

    }

    componentDidMount() {


    }



}
export default Search;


// WEBPACK FOOTER //
// ./src/search/search.js